
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductsGrid1 extends Serenity.EntityGrid<OrderProductsRow, any> {
       
        protected getColumnsKey() { return 'Orders.OrderProducts'; }
        protected getDialogType() { return OrderProductsDialog; }
        protected getIdProperty() { return OrderProductsRow.idProperty; }
        protected getInsertPermission() { return OrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductsRow.localTextPrefix; }
        protected getService() { return OrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
            protected addButtonClick() {
            // debugger;
            //this.editItem({ ProductId: this.ProductId });
                this.editItem({ OrderId: this.OrderId, IsTab: true });

        }
        protected getQuickFilters() {

            var filters = super.getQuickFilters();
            filters.splice(Q.indexOf(filters, x => x.field == "OrderId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderSourceType"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderIsEmailSent"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderFranchiseeId"), 1);
            filters.splice(Q.indexOf(filters, x => x.field == "OrderShippingStatus"), 1);

            return filters;

        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {
            return this.OrderId != null;
        }

        private _OrderId: number;

        get OrderId() {
            return this._OrderId;
        }

        set OrderId(value: number) {
            //debugger;
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderProductsRow.Fields.OrderId, value);
                this.refresh();
            }
        }
    }
}